import React from 'react'
import classNames from 'classnames'

import Loading from '../Loading'

import styles from './EmptyState.module.css'

export default function EmptyState({ loading, children, className, tight }) {
  return (
    <div
      className={classNames(
        styles.emptyState,
        className,
        tight && styles.tight
      )}
    >
      {loading ? <Loading /> : children}
    </div>
  )
}
